import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';


import { AuthServiceInterface } from '@interfaces/auth-service.interface';
import { UserModel } from '@models/user.model';
import { emptyUser } from '@utilities/data.util';
import { Authenticate } from '@models/Authenticate.model';

@Injectable()
export class AuthService implements AuthServiceInterface {
    createUser$(user: UserModel): Observable<UserModel> {
        return of(user);
    }

    login$(credential: Authenticate): Observable<UserModel> {
        return of(emptyUser());
    }

    logout$(): Observable<boolean> {
        return of(true);
    }

    getCurrentUser(): UserModel {
        const user = JSON.parse(localStorage.getItem('CurrentUser'));
        return user;
    }

    getArea(): any {
        const user = JSON.parse(localStorage.getItem('CurrentUser'));
        const area = localStorage.getItem('access');
        if(area){
            return area;
        }else{
            return null;
        }
    }

    isAuthenticate(): boolean {
        return this.getCurrentUser() != null;
    }
}